<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="终端主机号/车牌号/车架号/分组名"
             style="width: 200px; margin-right: 3px;"></Input>
      <DatePicker size="small" type="daterange" v-model="selectAnalysisDatetime" placeholder="选择日期"
                  style="margin-right: 3px; width: 200px;"></DatePicker>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
<!--      <Button size="small" type="primary" style="margin-right: 3px;" @click="onExportExcelClick">导出</Button>-->
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onDeleteClick">删除</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onAttentionAnalysisClick">手动分析</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
              show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>
      </div>
    </Row>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal"></web-table-columns-modal>
    <gd-dlysjg-continuous-tracks-view-modal v-model="continuousTracksViewModal"
                                  :initValue="continuousTracksViewId"></gd-dlysjg-continuous-tracks-view-modal>
    <delete-gd-dlysjg-vehicle-analyze-report-modal v-model="deleteTracksIntegrityAnalysissModal"></delete-gd-dlysjg-vehicle-analyze-report-modal>
    <analyze-gd-dlysjg-vehicle-report-modal v-model="analyzeGdDlysjgVehicleReportModal"></analyze-gd-dlysjg-vehicle-report-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import { mapActions } from 'vuex'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import { numberFormat } from '@/libs/numberutil'
  import GdDlysjgContinuousTracksViewModal from '@/view/gd-dlysjg/components/gd-dlysjg-continuous-tracks-view-modal'
  import DeleteGdDlysjgVehicleAnalyzeReportModal from '@/view/gd-dlysjg/components/delete-gd-dlysjg-vehicle-analyze-report-modal'
  import AnalyzeGdDlysjgVehicleReportModal from '@/view/gd-dlysjg/components/analyze-gd-dlysjg-vehicle-report-modal'
  import { genURLParams } from '@/libs/urlparamhelper'

  export default {
    name: 'gddlysjgvehicleanalyzereports',
    components: {
      GdDlysjgContinuousTracksViewModal,
      DeleteGdDlysjgVehicleAnalyzeReportModal,
      AnalyzeGdDlysjgVehicleReportModal
    },
    data () {
      return {

        vehicleTypeNameFilter:[],
        vehicleTypeNameType:[{label:'重型货车', value:'重型货车'}, {label:'客运车辆', value:'客运车辆'}, {label:'危险货运', value:'危险货运'}],

        // 生成轨迹完整率
        analyzeGdDlysjgVehicleReportModal: false,

        // 删除轨迹完整率
        deleteTracksIntegrityAnalysissModal: false,

        // 轨迹完整率过滤器
        tracksIntegrityPercentFilter: null,

        selectAnalysisDatetime: [],

        // 连续轨迹覆盖图
        continuousTracksViewModal: false,
        continuousTracksViewId: null,

        webTableColumnsModal: false,
        menuList: [
          { title: '设置表格列', content: {} }
        ],

        stateFilter: null,

        pageFilter: 30,
        pagesizeopts:[30, 50,100,200],
        keywordFilter: null,
        tableHeight: 160,
        pageIndex: 1,
        sort: null,
        listLoadding: false,

        columns: [
          {
            title: 'ID',
            resizable: true,
            key: 'id',
            sortable: 'custom',
            tooltip: 'true',
            width: 110
          },
          {
            title: '车牌号',
            resizable: true,
            key: 'registrationNum',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            render: (h, params) => {

                if (params.row.registrationNum) {
                  return h('div', params.row.registrationNum)
                } else {
                  return h('div', '无')
                }
            }
          },
          {
            title: '车辆类型',
            resizable: true,
            key: 'vehicleTypeName',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            filters: [{label:'重型货车', value:'重型货车'}, {label:'客运车辆', value:'客运车辆'}, {label:'危险货运', value:'危险货运'}],
            filterMultiple: true,
            filterRemote: (val) => {
              if (val.length > 0) {
                this.vehicleTypeNameFilter = []
                val.forEach(item => {
                  this.vehicleTypeNameFilter.push(genQueryParam('vehicleTypeName', 'EQSTR', item))
                })
              } else {
                this.vehicleTypeNameFilter = null
              }
            },
            render: (h, params) => {
              if (params.row.vehicleTypeName != null) {
                for (let i = 0; i < this.vehicleTypeNameType.length; i++) {
                  if (params.row.vehicleTypeName == this.vehicleTypeNameType[i].value) {
                    return h('label', this.vehicleTypeNameType[i].label)
                  }
                }
              }
            }
          },
          {
            title: '业户名称',
            resizable: true,
            key: 'yeHuMingCheng',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            render: (h, params) => {

                if (params.row.yeHuMingCheng) {
                  return h('div', params.row.yeHuMingCheng)
                } else {
                  return h('div', '无')
                }
            }
          },
          // {
          //   title: '终端主机号',
          //   resizable: true,
          //   key: 'imei',
          //   ellipsis: 'true',
          //   tooltip: 'true',
          //   width: 140
          // },
          {
            title: '连续里程',
            resizable: true,
            sortable: 'custom',
            key: 'continuityMileage',
            ellipsis: 'true',
            tooltip: 'true',
            width: 160,
            render: (h, params) => {
              return h('div', params.row.continuityMileage / 10)
            }
          },
          {
            title: '总里程',
            resizable: true,
            sortable: 'custom',
            key: 'allMileage',
            ellipsis: 'true',
            tooltip: 'true',
            width: 160,
            render: (h, params) => {
              return h('div', params.row.allMileage / 10)
            }
          },
          {
            title: '轨迹完整率（%）',
            resizable: true,
            sortable: 'custom',
            key: 'integralMaterial',
            ellipsis: 'true',
            tooltip: 'true',
            width: 170,
            filters: [
              {
                label: '90%以下',
                value: 90
              }
            ],
            filterMultiple: false,
            filterRemote: (val) => {
              if (val && val.length > 0) {
                this.tracksIntegrityPercentFilter = []
                val.forEach(item => {
                  this.tracksIntegrityPercentFilter.push(genQueryParam('integralMaterial', 'LE', item))
                })
              } else {
                this.tracksIntegrityPercentFilter = null
              }
              this.setPage(1)
            },
            render: (h, params) => {
              if (params.row.integralMaterial) {
                return h('div', params.row.integralMaterial)
              } else {
                return h('div', '-')
              }
            }
          },
          {
            title: '上线率（%）',
            resizable: true,
            sortable: 'custom',
            key: 'onlinePercent',
            ellipsis: 'true',
            tooltip: 'true',
            width: 160
          },
          {
            title: '分析时间',
            resizable: true,
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'analyzeDatetime',
            width: 180,
            render: function (h, params) {
              if (params.row.analyzeDatetime) {
                let d = new Date(params.row.analyzeDatetime)
                return h('div', d.Format('yyyy年MM月dd日'))
              }
            }
          },
          {
            title: '创建时间',
            resizable: true,
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'createDatetime',
            width: 180,
            render: function (h, params) {
              if (params.row.createDatetime) {
                let d = new Date(params.row.createDatetime)
                return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
              }
            }
          },
          {
            title: '操作',
            resizable: true,
            key: 'action',
            align: 'left',
            ellipsis: 'true',
            fixed: 'right',
            width: 180,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.continuousTracksViewModal = true
                      this.continuousTracksViewId = params.row.id
                    }
                  }
                }, '查看覆盖图')
              ])
            }
          }
        ]// cloumn
      }// return
    }, // data
    methods: {
      ...mapActions([
        'ClientInfoServ_GetPage'
      ]),
      /**
       * 表格右键回调
       */
      onTableRightClick (e) {
        this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
      },
      /**
       * 右键菜单点击回调
       */
      onContextMenuCallback (item) {
        if (item.title === '设置表格列') {
          this.webTableColumnsModal = true
        }
      },
      onSuccess () {
        this.setPage(1)
      },
      onModifySuccess () {
        this.refreshPage(this.pageFilter)
      },
      onFilterClick () {
        this.setPage(1)
      },
      onDeleteClick () {
        this.deleteTracksIntegrityAnalysissModal = true
      },
      onAttentionAnalysisClick () {
        this.analyzeGdDlysjgVehicleReportModal = true
      },
      onExportExcelClick () {
        let queryParams = []
        let qo1 = null
        let qo2 = null
        if (this.stateFilter) {
          qo1 = this.stateFilter
        }
        if (this.offlineFilter) {
          qo2 = this.offlineFilter
        }
        if (this.selectAnalysisDatetime[0] && this.selectAnalysisDatetime[1]) {
          let startDatetime = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
          let endDatetime = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
          queryParams.push(genQueryParam('analyzeDatetime', 'BTDT', startDatetime, endDatetime))
        }
        let urlparams = {
          qo1: qo1,
          qo2: qo2,
          q: queryParams,
          keyword: this.keywordFilter
        }
        let url = '/api/da/gddlysjgvehicleanalyzereport/exportexcel' + genURLParams(urlparams)
        window.location.href = url
      },
      filterChange () {
        this.setPage(1)
      },
      sortChange ({ column, key, order }) {
        this.sort = {
          name: key,
          asc: order === 'asc'
        }
        this.refreshPage(this.pageFilter)
      },
      setPage (page) {
        console.log('setPage' + page)
        this.pageIndex = page
        this.listLoadding = true

        let queryParams = []
        let sortParam = null
        let qo1 = null
        let qo2 = null
        let qo3 = null
        let qo4 = null

        if (this.sort) {
          sortParam = genSortParam(this.sort.name, this.sort.asc)
        }
        if (this.stateFilter) {
          qo1 = this.stateFilter
        }
        if (this.offlineFilter) {
          qo2 = this.offlineFilter
        }
        if (this.tracksIntegrityPercentFilter) {
          qo3 = this.tracksIntegrityPercentFilter
          queryParams.push(genQueryParam('allMileage', 'GT', 0))
        }
        if(this.vehicleTypeNameFilter){
          qo4 = this.vehicleTypeNameFilter;
        }

        if (this.selectAnalysisDatetime[0] && this.selectAnalysisDatetime[1]) {
          let startDatetime = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
          let endDatetime = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
          queryParams.push(genQueryParam('analyzeDatetime', 'BTDT', startDatetime, endDatetime))
        }

        store.dispatch('GdDlysjgVehicleAnalyzeReportServ_GetPage', {
          params: null,
          urlparams: {
            qo1: qo1,
            qo2: qo2,
            qo3: qo3,
            qo4: qo4,
            q: queryParams,
            ps: this.pageFilter,
            p: page,
            keyword: this.keywordFilter,
            sort: sortParam
          }
        }).then(() => {
          this.listLoadding = false
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        })
      },
      // 刷新当前页
      refreshPage (value) {
        this.pageFilter = value
        this.setPage(this.pageIndex)
      }
    },
    computed: {
      totalElements () {
        if (store.getters.get_GdDlysjgVehicleAnalyzeReport_GetPageResult) {
          return store.getters.get_GdDlysjgVehicleAnalyzeReport_GetPageResult.totalElements
        } else {
          return 0
        }
      },
      content () {
        if (store.getters.get_GdDlysjgVehicleAnalyzeReport_GetPageResult) {
          return store.getters.get_GdDlysjgVehicleAnalyzeReport_GetPageResult.content
        } else {
          return []
        }
      },
      pageSize () {
        if (store.getters.get_GdDlysjgVehicleAnalyzeReport_GetPageResult) {
          return store.getters.get_GdDlysjgVehicleAnalyzeReport_GetPageResult.size
        } else {
          return 0
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        // this.selectAnalysisDatetime = new Date()
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
        window.onresize = () => {
          this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
        }
        this.setPage(1)
      })
    }
  }
</script>

<style scoped>
</style>
